import { motion } from "framer-motion";
import React from "react";
import styled from "styled-components";

function AboutBanner() {
  return (
    <>
      <Wrapper>
        <Container>
          <div
            className="side-label"
            style={{
              position: "fixed",
              transform: "rotate(-90deg)",
              top: "50%",
              left: "50px",
              margin: "auto",
            }}
          >
            <Overflow style={{ position: "relative", marginBottom: "60px" }}>
              <RevealBar
                initial={{
                  width: "0%",
                  top: 0,
                  height: "100%",
                  position: "absolute",
                }}
                whileInView={{ width: "100%", x: ["0%", "0%", "0%", "100%"] }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
              />
              <Side
                initial={{ y: 10 }}
                whileInView={{ y: 0 }}
                transition={{ delay: 1, transition: 1 }}
              >
                {" "}
                ABOUT{" "}
              </Side>
            </Overflow>
          </div>
          <div>
            <Head>
              <Span
                initial={{ opacity: 0, y: "100%" }}
                whileInView={{ opacity: 1, y: "0%" }}
                transition={{ delay: 1 }}
                viewport={{ once: true }}
              >
                I build interfaces people
              </Span>
              <RevealBar
                initial={{
                  width: "0%",
                  top: 0,
                  height: "100%",
                  position: "absolute",
                }}
                whileInView={{ width: "100%", x: ["0%", "0%", "0%", "100%"] }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
              />
            </Head>
            <Head>
              <Span
                initial={{ opacity: 0, y: "100%" }}
                whileInView={{ opacity: 1, y: "0%" }}
                transition={{ delay: 1 }}
                viewport={{ once: true }}
              >
                actually enjoy using.
              </Span>
              <RevealBar
                initial={{
                  width: "0%",
                  top: 0,
                  height: "100%",
                  position: "absolute",
                }}
                whileInView={{ width: "100%", x: ["0%", "0%", "0%", "100%"] }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
              />
            </Head>
          </div>
          <Img>
            <RevealBar
              viewport={{ once: true }}
              initial={{
                width: "0%",
                top: 0,
                height: "100%",
                position: "absolute",
              }}
              whileInView={{ width: "100%", transform: "translateX(100%)" }}
              transition={{ duration: 1 }}
            />
            <motion.img
              viewport={{ once: true }}
              initial={{
                y: "320px",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "5px",
              }}
              whileInView={{ y: "0px" }}
              transition={{ delay: 1, duration: 1 }}
              // src="/Images/profile.jpg"
              src="/Images/profile.png"
              alt=""
            />
          </Img>
        </Container>
      </Wrapper>

      <motion.div
        style={{
          display: "flex",
          justifyContent: "start",
          gap: "clamp(24px, 6vw, 100px)",
          maxWidth: "1200px",
          margin: "auto",
          padding: "0 20px",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            gap: "30px",
            alignItems: "center",
          }}
        >
          <div style={{ position: "relative", overflow: "hidden" }}>
            <motion.h3
              viewport={{ once: true }}
              initial={{ y: "20px" }}
              whileInView={{ y: 0 }}
              transition={{ delay: 1 }}
            >
              /01{" "}
            </motion.h3>
            <RevealBar
              initial={{
                width: "0%",
                top: 0,
                height: "100%",
                position: "absolute",
              }}
              whileInView={{ width: "100%", x: ["0%", "0%", "0%", "100%"] }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
            />
          </div>
          <div style={{ position: "relative", overflow: "hidden" }}>
            <motion.h2
              viewport={{ once: true }}
              initial={{ y: "28px" }}
              whileInView={{ y: 0 }}
              transition={{ delay: 1 }}
            >
              Story
            </motion.h2>
            <RevealBar
              viewport={{ once: true }}
              initial={{
                width: "0%",
                top: 0,
                height: "100%",
                position: "absolute",
              }}
              whileInView={{ width: "100%", x: ["0%", "0%", "0%", "100%"] }}
              transition={{ duration: 1 }}
            />
          </div>
        </div>
        <div style={{ position: "relative", overflow: "hidden" }}>
          <motion.h2
            viewport={{ once: true }}
            initial={{ y: "28px" }}
            whileInView={{ y: 0 }}
            transition={{ delay: 1 }}
          >
            A short detail about me.
          </motion.h2>
          <RevealBar
            initial={{
              width: "0%",
              top: 0,
              height: "100%",
              position: "absolute",
            }}
            whileInView={{ width: "100%", x: ["0%", "0%", "0%", "100%"] }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
          />
        </div>
      </motion.div>
      <motion.div
        style={{ maxWidth: "1200px", margin: "auto", padding: "0 20px" }}
      >
        <motion.div
          style={{
            maxWidth: "900px",
            margin: "40px 0 40px auto",
            width: "100%",
          }}
        >
          <Pera
            viewport={{ once: true }}
            initial={{ y: "20px" }}
            whileInView={{ y: "0", opacity: 1 }}
            transition={{ delay: 1, duration: 0.5 }}
          >
            I'm Mohammad Savad, a self-taught front-end developer with a genuine
            passion for crafting clean, performant, and visually compelling web
            experiences. I work across the full front-end stack React,
            TypeScript, JavaScript, HTML, CSS and extend into the back-end with
            Node.js, Express, and MongoDB when the project calls for it.
          </Pera>

          <Pera
            viewport={{ once: true }}
            initial={{ y: "20px" }}
            whileInView={{ y: "0", opacity: 1 }}
            transition={{ delay: 1, duration: 0.5 }}
          >
            Over the past few years I've contributed at Limenzy Technologies,
            Lilac Infotech, and G3 Interactive building everything from Shopify
            and WooCommerce storefronts to dynamic React applications. Each
            engagement has sharpened my ability to write maintainable code,
            collaborate across teams, and ship high-quality products on time.
          </Pera>

          <Pera
            viewport={{ once: true }}
            initial={{ y: "20px" }}
            whileInView={{ y: "0", opacity: 1 }}
            transition={{ delay: 1, duration: 0.5 }}
          >
            I graduated in 2022 and have been learning continuously ever since.
            I believe great software is built at the intersection of clean
            engineering and thoughtful design and I strive to bring both to
            every project I take on.
          </Pera>
        </motion.div>
      </motion.div>

      <motion.div
        style={{
          display: "flex",
          justifyContent: "start",
          gap: "clamp(24px, 6vw, 100px)",
          maxWidth: "1200px",
          margin: "auto",
          padding: "0 20px",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            gap: "30px",
            alignItems: "center",
          }}
        >
          <div style={{ position: "relative", overflow: "hidden" }}>
            <motion.h3
              viewport={{ once: true }}
              initial={{ y: "20px" }}
              whileInView={{ y: 0 }}
              transition={{ delay: 1 }}
            >
              /02
            </motion.h3>
            <RevealBar
              initial={{
                width: "0%",
                top: 0,
                height: "100%",
                position: "absolute",
              }}
              whileInView={{ width: "100%", x: ["0%", "0%", "0%", "100%"] }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
            />
          </div>
          <div style={{ position: "relative", overflow: "hidden" }}>
            <motion.h2
              viewport={{ once: true }}
              initial={{ y: "28px" }}
              whileInView={{ y: 0 }}
              transition={{ delay: 1 }}
            >
              The Tools
            </motion.h2>
            <RevealBar
              initial={{
                width: "0%",
                top: 0,
                height: "100%",
                position: "absolute",
              }}
              whileInView={{ width: "100%", x: ["0%", "0%", "0%", "100%"] }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
            />
          </div>
        </div>
        <div style={{ position: "relative", overflow: "hidden" }}>
          <motion.h2
            viewport={{ once: true }}
            initial={{ y: "28px" }}
            whileInView={{ y: 0 }}
            transition={{ delay: 1 }}
          >
            What I use.
          </motion.h2>
          <RevealBar
            viewport={{ once: true }}
            initial={{
              width: "0%",
              top: 0,
              height: "100%",
              position: "absolute",
            }}
            whileInView={{ width: "100%", x: ["0%", "0%", "0%", "100%"] }}
            transition={{ duration: 1 }}
          />
        </div>
      </motion.div>
      <motion.div
        style={{ maxWidth: "1200px", margin: "auto", padding: "0 20px" }}
      >
        <motion.div
          style={{
            maxWidth: "900px",
            margin: "40px 0 40px auto",
            width: "100%",
          }}
        >
          <Pera
            initial={{ y: "20px" }}
            viewport={{ once: true }}
            whileInView={{ y: "0", opacity: 1 }}
            transition={{ delay: 1, duration: 0.5 }}
          >
            I choose the right tool for the job. For design I reach for Figma or
            Adobe XD; for development I work with the technologies listed below,
            adapting to whatever stack best fits the project.
          </Pera>

          <div
            style={{
              display: "flex",
              margin: "40px 0",
              gap: "40px",
              flexWrap: "wrap",
            }}
          >
            <div>
              <div style={{ position: "relative", overflow: "hidden" }}>
                <motion.h2
                  initial={{ y: "28px" }}
                  viewport={{ once: true }}
                  whileInView={{ y: 0 }}
                  transition={{ delay: 1 }}
                >
                  Creative Design
                </motion.h2>
                <RevealBar
                  initial={{
                    width: "0%",
                    top: 0,
                    height: "100%",
                    position: "absolute",
                  }}
                  viewport={{ once: true }}
                  whileInView={{
                    width: "100%",
                    x: ["0%", "0%", "0%", "100%"],
                  }}
                  transition={{ duration: 1 }}
                />
              </div>
              <div style={{ marginTop: "30px" }}>
                <motion.ul
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 1 }}
                >
                  <li style={{ marginBottom: "20px" }}>Figma</li>
                  <li style={{ marginBottom: "20px" }}>Adobe Photoshop</li>
                  <li style={{ marginBottom: "20px" }}>Adobe XD</li>
                </motion.ul>
              </div>
            </div>
            <div>
              <div style={{ position: "relative", overflow: "hidden" }}>
                <motion.h2
                  initial={{ y: "28px" }}
                  whileInView={{ y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 1 }}
                >
                  Web Development
                </motion.h2>
                <RevealBar
                  initial={{
                    width: "0%",
                    top: 0,
                    height: "100%",
                    position: "absolute",
                  }}
                  whileInView={{
                    width: "100%",
                    x: ["0%", "0%", "0%", "100%"],
                  }}
                  transition={{ duration: 1 }}
                  viewport={{ once: true }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "40px",
                  marginTop: "30px",
                  flexWrap: "wrap",
                }}
              >
                <div>
                  <motion.ul
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 1 }}
                  >
                    <li style={{ marginBottom: "20px" }}>HTML 5</li>
                    <li style={{ marginBottom: "20px" }}>CSS 3</li>
                    <li style={{ marginBottom: "20px" }}>JavaScript</li>
                    <li style={{ marginBottom: "20px" }}>TypeScript</li>
                    <li style={{ marginBottom: "20px" }}>Node JS</li>
                  </motion.ul>
                </div>
                <div>
                  <motion.ul
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 1 }}
                  >
                    <li style={{ marginBottom: "20px" }}>Express JS</li>
                    <li style={{ marginBottom: "20px" }}>React JS</li>
                    <li style={{ marginBottom: "20px" }}>Redux</li>
                    <li style={{ marginBottom: "20px" }}>Wordpress</li>
                    <li style={{ marginBottom: "20px" }}>woocommerce</li>
                  </motion.ul>
                </div>
                <div>
                  <motion.ul
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 1 }}
                  >
                    <li style={{ marginBottom: "20px" }}>Git</li>
                    <li style={{ marginBottom: "20px" }}>NPM</li>
                    <li style={{ marginBottom: "20px" }}>Yarn</li>
                    <li style={{ marginBottom: "20px" }}>Firebase</li>
                    <li style={{ marginBottom: "20px" }}>MongoDB</li>
                  </motion.ul>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </motion.div>

      <motion.div
        style={{
          display: "flex",
          justifyContent: "start",
          gap: "clamp(24px, 6vw, 100px)",
          maxWidth: "1200px",
          margin: "auto",
          padding: "0 20px",
          flexWrap: "wrap",
          alignItems: "start",
        }}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            gap: "30px",
            alignItems: "center",
          }}
        >
          <div style={{ position: "relative", overflow: "hidden" }}>
            <motion.h3
              viewport={{ once: true }}
              initial={{ y: "20px" }}
              whileInView={{ y: 0 }}
              transition={{ delay: 1 }}
            >
              /03
            </motion.h3>
            <RevealBar
              viewport={{ once: true }}
              initial={{
                width: "0%",
                top: 0,
                height: "100%",
                position: "absolute",
              }}
              whileInView={{ width: "100%", x: ["0%", "0%", "0%", "100%"] }}
              transition={{ duration: 1 }}
            />
          </div>
          <div style={{ position: "relative", overflow: "hidden" }}>
            <motion.h2
              viewport={{ once: true }}
              initial={{ y: "28px" }}
              whileInView={{ y: 0 }}
              transition={{ delay: 1 }}
            >
              Contact{" "}
            </motion.h2>
            <RevealBar
              viewport={{ once: true }}
              initial={{
                width: "0%",
                top: 0,
                height: "100%",
                position: "absolute",
              }}
              whileInView={{ width: "100%", x: ["0%", "0%", "0%", "100%"] }}
              transition={{ duration: 1 }}
            />
          </div>
        </div>
        <div>
          <div>
            <div
              style={{
                position: "relative",
                overflow: "hidden",
                width: "fit-content",
              }}
            >
              <motion.h2
                style={{ width: "fit-width" }}
                viewport={{ once: true }}
                initial={{ y: "28px" }}
                whileInView={{ y: 0 }}
                transition={{ delay: 1 }}
              >
                Social
              </motion.h2>
              <RevealBar
                viewport={{ once: true }}
                initial={{
                  width: "0%",
                  top: 0,
                  height: "100%",
                  position: "absolute",
                }}
                whileInView={{ width: "100%", x: ["0%", "0%", "0%", "100%"] }}
                transition={{ duration: 1 }}
              />
            </div>
            <div>
              <motion.ul
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                  marginTop: "40px",
                  marginBottom: "40px",
                  flexWrap: "wrap",
                  rowGap: "12px",
                }}
                initial={{ y: 30, opacity: 0 }}
                viewport={{ once: true }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: 1 }}
              >
                <li>
                  <ListAnchor
                    target="_blank"
                    href="https://www.linkedin.com/in/savadneeliyan/"
                  >
                    LinkedIn
                  </ListAnchor>
                </li>
                <Slash>/</Slash>

                <li>
                  <ListAnchor
                    target="_blank"
                    href="https://www.instagram.com/that_s_guy/"
                  >
                    <motion.div style={{ overflow: "hidden" }}>
                      Instagram
                    </motion.div>
                  </ListAnchor>
                </li>

                <Slash>/</Slash>

                <li>
                  <ListAnchor
                    target="_blank"
                    href="https://www.facebook.com/savad.kvr/"
                  >
                    <motion.div style={{ overflow: "hidden" }}>
                      Facebook
                    </motion.div>
                  </ListAnchor>
                </li>
              </motion.ul>
            </div>
          </div>
          <div style={{ marginBottom: "60px" }}>
            <div>
              <div
                style={{
                  position: "relative",
                  overflow: "hidden",
                  width: "fit-content",
                }}
              >
                <motion.h2
                  viewport={{ once: true }}
                  initial={{ y: "28px" }}
                  whileInView={{ y: 0 }}
                  transition={{ delay: 1 }}
                >
                  Gmail
                </motion.h2>
                <RevealBar
                  viewport={{ once: true }}
                  initial={{
                    width: "0%",
                    top: 0,
                    height: "100%",
                    position: "absolute",
                  }}
                  whileInView={{
                    width: "100%",
                    x: ["0%", "0%", "0%", "100%"],
                  }}
                  transition={{ duration: 1 }}
                />
              </div>
            </div>
            <div style={{ marginTop: "50px" }}>
              <motion.ul
                initial={{ y: 30, opacity: 0 }}
                viewport={{ once: true }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: 1 }}
              >
                <li style={{ width: "fit-content" }}>
                  <ListAnchor href="mailto:savadn632@gmail.com">
                    <motion.div style={{ overflow: "hidden" }}>
                      savadn632@gmail.com
                    </motion.div>
                  </ListAnchor>
                </li>
              </motion.ul>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
}

export default AboutBanner;

const Container = styled(motion.div)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
  }
`;

const Wrapper = styled(motion.div)`
  max-width: 1200px;
  margin: auto;
  height: 80vh;
  display: flex;
  align-items: center;
  padding: 0 20px;

  @media (max-width: 1430px) {
    padding: 0 30px;
  }
  @media (max-width: 768px) {
    height: auto;
    padding: 120px 20px 40px;
  }
`;

const Img = styled(motion.div)`
  position: relative;
  overflow: hidden;
  width: 300px;
  height: 320px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 200px;
    height: 220px;
  }
`;

const Head = styled(motion.h1)`
  overflow: hidden;
  position: relative;
  width: fit-content;
  font-size: 40px;
  line-height: 50px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 36px;
  }
`;

const Span = styled(motion.h5)`
  /* transform: translateY(20px) translateZ(0px); */
`;

const Pera = styled(motion.p)`
  font-size: 18px;
  line-height: 32px;
  opacity: 0;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 15px;
    line-height: 26px;
  }
`;

const Slash = styled.h3`
  font-size: 25px;
  font-weight: 300;
  font-family: "Poppins";
  color: var(--text-2);
`;

const ListAnchor = styled.a`
  color: var(--text-2);
  font-size: 20px;
  transition: 0.5s linear;
  display: block;
  position: relative;
  &:hover {
    text-decoration: none;
    transform: translateX(10px);
    transition: 0.3s linear;
  }
  &::before {
    content: "";
    position: absolute;
    width: 0%;
    background: var(--text);
    height: 2px;
    top: 50%;
    left: -5px;
    display: block;
    transition: 0.5s linear;
  }
  &:hover::before {
    width: 115%;
  }
`;

const Overflow = styled(motion.div)`
  overflow: hidden;
  width: fit-content;
  position: relative;
`;

const Side = styled(motion.h4)`
  font-size: 12px;
  line-height: 10px;
  font-weight: 400;
`;

const RevealBar = styled(motion.div)`
  background: var(--overlay);
  transition: background 0.3s ease;
`;
